/**
 * Check invoice values
 * @param {Object} invoice
 * @returns {Boolean} true if invoice is complete (non null values)
 */
export default function useInvoiceCheck(invoice) {
  const requiredInvoiceKeys = [
    "reference",
    "creation_date",
    "type",
    "amount_without_tax",
    "amount_with_tax",
    "due_date",
    "counterparty",
  ];
  const invoiceFilled = requiredInvoiceKeys.reduce(
    (prev, currentKey) => prev && invoice[currentKey] !== null,
    true,
  );
  return invoiceFilled;
}
